// 商用版试用
// http://api.umucdn.cn/project/216/interface/api/3056
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    enterprise_name?: string;
}

export interface IOutput {
    enterprise_id: number;
}

// tslint:disable-next-line:max-line-length
export const applyForCommericalTrial = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.APPLY_FOR_COMMERICAL_TRIAL, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
